import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ffdNotesRoutePrefix, routes } from '@libs/utils';
import { TranslatePipe } from '@ngx-translate/core';
import { BaaSignupFlowService } from '../baa-sign-up-flow.service';

@Component({
  selector: 'lib-baa-signup-info',
  imports: [TranslatePipe, RouterModule],
  templateUrl: './baa-sign-up-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaaSignupInfoComponent {
  protected readonly service = inject(BaaSignupFlowService);
  protected readonly routes = routes;
  protected readonly ffdNotesRoutePrefix = ffdNotesRoutePrefix;

  protected onContinue(): void {
    this.service.registerWithEmail();
  }
}
